// 'use client' 없이 서버/클라이언트 모두에서 안전하게 import 가능한 스토리지 키 상수.
// (storage.ts 는 localStorage 접근 때문에 'use client' 이므로, 상수는 별도 모듈로 분리한다)

export const STORAGE_KEYS = {
  NOTIFY_CHANGE_ADDRESS: 'notify-change-address',
  NOTIFY_CHANGE_DEFAULT_ADDRESS: 'notify-change-default-address',
  NOTIFY_ADD_NEW_ADDRESS: 'notify-add-new-address',
  OPEN_POST_FORM_URL: 'open-post-form-url',
  OPEN_POST_FORM_URL_PAYLOAD: 'open-post-form-url-payload',
  OPEN_GET_FORM_URL: 'open-get-form-url',
  OPEN_GET_FORM_URL_PAYLOAD: 'open-get-form-url-payload',
  SET_PAYMENT_ID: 'set-payment-id',
  SAVE_REFUND_ACCOUNT: 'save-refund-account',
  BUSINESS_ID: 'businessId',
  REFERRER: 'referrer',
  TOKEN: 'token',
};

export type StorageKeyType = keyof typeof STORAGE_KEYS;
